import {
  ConfigState,
  loadoutCartState,
} from "../../components/loadouts/common/types";

export const initialLoadoutConfigState: ConfigState = {
  displayPresellerSummary: false,
  displayRsuSummary: false,
  presellerRouteMaintained: false,
  rsuRouteMaintained: false,
  summaryKeys: [],
  maxDeliveryDateOffset: 0,
  minDeliveryDateOffset: 0,
  gapBetweenCreationAndDeliveryDate: 0,
  maxInvoiceSelectionLimit: 50,
  dataDisplayPreference: [],
  enableSalesmanAssignment: false,
  enableDeliveryRouteFilter: false,
  enableVehicleAssignment: false,
  enableDeliveryDateAssignment: false,
  dateFilter: "deliveryDate",
  allowedStatuses: {
    createLoadout: [],
    inTransitLoadout: [],
    deliveredLoadout: [],
  },
  loadslipMultipleFilters: [],
  isStockServiceEnabled: false,
  enableStgExcelLoadoutSheetDownload: false,
  invoiceActions: {
    DisplayEyeIcon: false,
    DisplayDownloadIcon: false,
  },
  orderActions: {
    DisplayEyeIcon: false,
    DisplayDownloadIcon: false,
  },
  loadoutActions: {
    DisplayEyeIcon: false,
    DisplayDownloadIcon: false,
  },
  vehicleUOMKeys: {},
  displayVehicleCapacityValidationErrorMessage: false,
  enableVehicleCapacityValidation: false,
  salesmanDesignations: [],
  salesrepDesignations: [],
  loadslipGroupByField: "",
  loadslipColumnLabel: "",
  salesDataApiTemplateVersion: "version2",
  filtersConfig: [],
  presellerColumnsConfig: {
    columns: [],
    Actions: [],
  },
  loadoutColumnsConfig: {
    columns: [],
    Actions: [],
  },
  batchIdConfiguration: false,
};

const initialState: loadoutCartState = {
  totals: {
    totalAmount: 0,
    totalCase: 0,
    totalPiece: 0,
    totalOther: 0,
  },
  cartData: {
    product: {},
    loadout: {},
    salesData: [],
    loadoutData: [],
  },
  preseller: true,
  switchState: false,
  loadoutConfig: initialLoadoutConfigState,
};

const presellerReducer = (
  state = initialState,
  action: any
): loadoutCartState => {
  switch (action.type) {
    case "SET_TOTALS":
      return {
        ...state,
        totals: {
          ...state.totals,
          ...action.payload,
        },
      };
    case "TOGGLE_SWITCH_STATE":
      return {
        ...state,
        switchState: !state.switchState,
      };
    case "SET_SWITCH_STATE":
      return {
        ...state,
        switchState: action.payload,
      };
    case "SET_PRESELLER_LOADOUT":
      return {
        ...state,
        ...action.payload,
      };
    case "RESET_PRESELLER_LOADOUT":
      return {
        ...initialState,
        totals: {
          totalAmount: 0,
          totalCase: 0,
          totalPiece: 0,
          totalOther: 0,
        },
      };
    case "RESET_PRESELLER_LOADOUT_WITHOUT_CONFIG":
      return {
        ...initialState,
        totals: {
          totalAmount: 0,
          totalCase: 0,
          totalPiece: 0,
          totalOther: 0,
        },
        loadoutConfig: state.loadoutConfig,
      };
    case "SET_PRODUCT":
      return {
        ...state,
        cartData: {
          loadout: state.cartData?.loadout || {},
          salesData: state.cartData?.salesData || [],
          loadoutData: state.cartData?.loadoutData || [],
          product: action.payload,
        },
      };
    case "RESET_PRODUCT":
      return {
        ...state,
        cartData: {
          product: initialState?.cartData?.product || {},
          loadout: state.cartData?.loadout || {},
          salesData: state.cartData?.salesData || [],
          loadoutData: state.cartData?.loadoutData || [],
        },
      };
    case "SET_LOADOUT":
      return {
        ...state,
        cartData: {
          loadout: { ...state.cartData?.loadout, ...action.payload },
          salesData: state.cartData?.salesData || [],
          loadoutData: state.cartData?.loadoutData || [],
          product: state.cartData?.product || {},
        },
      };
    case "RESET_LOADOUT":
      return {
        ...state,
        cartData: {
          loadout: initialState?.cartData?.loadout || {},
          product: state.cartData?.product || {},
          salesData: state.cartData?.salesData || [],
          loadoutData: state.cartData?.loadoutData || [],
        },
      };
    case "RESET_CART_DATA":
      return {
        ...state,
        cartData: {
          loadout: state.cartData?.loadout || {},
          product: initialState?.cartData?.product || {},
          salesData: initialState?.cartData?.salesData || [],
          loadoutData: state.cartData?.loadoutData || [],
        },
        totals: {
          totalAmount: 0,
          totalCase: 0,
          totalPiece: 0,
          totalOther: 0,
        },
      };
    case "SET_SALES_DATA":
      return {
        ...state,
        cartData: {
          salesData: action.payload,
          loadoutData: state.cartData?.loadoutData || [],
          loadout: state.cartData?.loadout || {},
          product: state.cartData?.product || {},
        },
      };
    case "RESET_SALES_DATA":
      return {
        ...state,
        cartData: {
          salesData: initialState?.cartData?.salesData || [],
          loadoutData: state.cartData?.loadoutData || [],
          product: state.cartData?.product || {},
          loadout: state.cartData?.loadout || {},
        },
      };
    case "SET_LOADOUT_DATA":
      return {
        ...state,
        cartData: {
          salesData: state.cartData?.salesData || [],
          loadoutData: action.payload || {},
          loadout: state.cartData?.loadout || {},
          product: state.cartData?.product || {},
        },
      };
    case "RESET_LOADOUT_DATA":
      return {
        ...state,
        cartData: {
          salesData: state?.cartData?.salesData || [],
          loadoutData: initialState.cartData?.loadoutData || [],
          product: state.cartData?.product || {},
          loadout: state.cartData?.loadout || {},
        },
      };
    case "SET_LOADOUT_CONFIG":
      return {
        ...state,
        loadoutConfig: {
          ...state.loadoutConfig,
          ...action.payload,
        },
      };
    case "RESET_LOADOUT_CONFIG":
      return {
        ...state,
        loadoutConfig: initialState.loadoutConfig,
      };
    default:
      return state;
  }
};

export default presellerReducer;
